import { TitleFilterModifierEnum } from "@clockwise/schema";
import React from "react";
import { useUpdateEventSearchFilters } from "../../../../hooks/event-search-filters/useUpdateEventSearchFilters";
import { BaseChip } from "./BaseChip";
import { convertEnumToPascalCase } from "./convertEnumToPascalCase";

export const TitleFilter = ({
  modifier,
  title,
  eventSearchBlockId,
  conversationId,
  disabled = false,
}: {
  title: string;
  modifier: TitleFilterModifierEnum;
  eventSearchBlockId: string;
  conversationId: string;
  disabled?: boolean;
}) => {
  const { updateTitleFilter } = useUpdateEventSearchFilters();
  const onDelete = () => {
    updateTitleFilter(eventSearchBlockId, conversationId, null);
  };

  const filterTextComponent = (
    <>
      <span className="cw-text-subtle">{convertEnumToPascalCase(modifier)}</span> {title}
    </>
  );

  return (
    <BaseChip disabled={disabled} onDelete={onDelete}>
      {filterTextComponent}
    </BaseChip>
  );
};
